import { Component, OnInit, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { CommonUtil } from '../../../../core/Utils/common-util';

import { RootScopeService } from '../../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../../core/rootscope-declare';
import { onboardingEquipmentObject } from '../../../services/equipment.model';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { FacilityService } from '../../../../core/services/facility.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { EquipmentService } from '../../../services/equipment.service';
import { HaloLoaderService } from '../../../../core/halo-loader/halo-loader.service';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';

@Component({
  selector: 'app-add-onboarding-equipment',
  templateUrl: './add-onboarding-equipment.component.html',
  styleUrls: ['./add-onboarding-equipment.component.scss']
})
export class AddOnboardingEquipmentComponent implements OnInit , OnChanges{
  rootScopeData: RootScopeDeclare;
  @Input() availableEquipments:onboardingEquipmentObject[];
  @Input() registeredEquipments:onboardingEquipmentObject[];
  @Output() callOnClick: EventEmitter<string> = new EventEmitter();
  availEquipments: onboardingEquipmentObject[];
  currentFacilityRegEquipment: onboardingEquipmentObject[];
  currentFacility: FacilityObject;
  availSelectAll: boolean  = false;
  registeredSelectAll: boolean = false;
  addedEquipments:any = {};
  disabled: boolean = true;


  // subscriptions
  private _facilityOnChange: Subscription;

//   @Input() set availableEquipments(value: onboardingEquipmentObject[]) {
//     this.availEquipments = value;
//     // this.availEquipments.forEach((availEquip: onboardingEquipmentObject) =>{
//     //   availEquip['selected']= true;
//     // });
//     for (let equip of this.availEquipments) {
//       equip['selected']= true;            
//       console.log("available equipments: " +JSON.stringify(equip));
//     }
    
//     this.availSelectAll = true; 
//  }

//  get availableEquipments(): onboardingEquipmentObject[] {
//   console.log("registered equipments: " +JSON.stringify(this.availEquipments));
//   return this.availEquipments; 
// }
 

//   @Input() set registeredEquipments(value: onboardingEquipmentObject[]) {
//     this.currentFacilityRegEquipment = value.filter(item => {
//       return item.facilityId.toString() === this.currentFacility.facilityId
//     });
//     this.currentFacilityRegEquipment.forEach((equip: onboardingEquipmentObject) =>{
//       equip['selected']= true;
//     });
//     this.registeredSelectAll = true;
 
//  }
 
//  get registeredEquipments(): onboardingEquipmentObject[] {
//      return this.currentFacilityRegEquipment; 
//  }

  constructor(private rootScopeService: RootScopeService, private _commonUtil: CommonUtil,
    private _facilityService: FacilityService, private _router: Router,
    private _amplitudeAnalytics: AmplitudeAnalyticsService,
    private _equipmentService:EquipmentService,
    private _loader: HaloLoaderService) { }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe((rootScopeData) => (this.rootScopeData = rootScopeData));
  }

  ngOnInit(): void {
    this._amplitudeAnalytics.logEvent({elementName: 'Page', action: 'Loaded', additionalProperty: {subFeatureName: 'Add Onboarding Equipment'}});
    this.getRootScopeData();
    this.currentFacility = this._facilityService.selectedFacility();
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe((res) => {
      this.currentFacility = res;
    });
  }

  ngOnChanges(changes: SimpleChanges) {    
    this.availSelectAll = true;
    if(changes.availableEquipments.currentValue){
      this.availEquipments = changes.availableEquipments.currentValue;
      this.availEquipments.forEach((equip: onboardingEquipmentObject) =>{
        equip['selected']= true;
      });
    }
    this.registeredSelectAll = true;
    if(changes.registeredEquipments.currentValue){      
      this.currentFacilityRegEquipment = changes.registeredEquipments.currentValue;
      this.currentFacilityRegEquipment.forEach((equip: onboardingEquipmentObject) =>{
        equip['selected']= true;
      });
    }
  }

  ngOnDestroy() {
    // destroy subscriber
    if (this._facilityOnChange) {
      this._facilityOnChange.unsubscribe();
    }
  }

  getConsoleByModelId(modelId: string): string {
    this.rootScopeData.consoleRights.forEach(function (consoleRight) {
      if (consoleRight.modelIds.indexOf(modelId.toString()) > -1) {
        return consoleRight.consoleType.toUpperCase();
      }
    })
    return 'ICG';
  }

  
  goToOldAddEquipment(): void {
    this.callOnClick.emit();    
  }

  onCancel(): void{
    this._router.navigate(['/facility/equipment']);
  }

  addOnboardingEquipment() : void{
    let postData = {
      "facilityId":this.currentFacility.facilityId
    }
    this._loader.startProcess();
    this._amplitudeAnalytics.logEvent({elementName: 'Add', action: 'Submit', additionalProperty: {subFeatureName: 'Add Onboarding Equipment'}});
    this._equipmentService.postOnboardingEquipmentData(postData)
        .subscribe(
          (data: any) => {
            this.addedEquipments = data.equipmentIds;
            this._loader.endProcess();
          },
          error => {
            console.error('API failed.');
            this._loader.endProcess();
          }
        )
        // this._amplitudeAnalytics.logEvent(
        //   'Facility - Equipment - Add Equipment', { 'equipments':this.addedEquipments}
        // );
        this._router.navigate(['/facility/equipment']);
		// 	equipmentFactory.registerNewEquipmentViaExternalIP(datainput).then(function(result){
		// 		//showToast this.assetRegisterSuccessMsg = 'Asset Registration Successfully completed !';
		// 		$scope.isAssetRegistrationFailed = false;
		// 		$scope.$parent.setupFacilityProgressBar($rootScope.lastSelectedFacilityId);
		// 		trackEvent(gaConstants.category.Equipment, gaConstants.action.AddEquipment, result.data.equipmentIds);				
		// 		$scope.showNewEquipment = false;
		// 		$scope.$parent.showNewFacilityMessage = true;
		// 		if($scope.$parent.isConnectedFacility=="false")
		// 			$scope.$parent.isNewEquipmentCreated = true;
		// 		else
		// 			$scope.$parent.isNewEquipmentCreated = false;				
		// 		$rootScope.hasEquipmentChanges = false;
		// 		$rootScope.getFacilityInformation();
		// 		$scope.equipmentReload();
		// 		$scope.$parent.getManagerTypeRightsFromUserAccount();
		// 	},
		// 	function(error){
		// 		this.isAssetRegistrationFailed = true;				
		// 		$rootScope.showToast('Asset Registration Failed. Try again.', "error");
		// 		/*START added to go dashboard when failure happens*/
		// 		$scope.showNewEquipment = false;
		// 		$scope.$parent.showNewFacilityMessage = true;
		// 		window.location.href = 'halo.html#/facility/manage';
		// 		/*END added to go dashboard when failure happens*/
		// 		//this.errorMsg = 'Asset Registration Failed. Try again.';
		// 	}
		// 	);
		// }
	}

}
